import L from 'leaflet';
import { ValidationHelper } from '../../../../../helpers';
// Layer that accept custom variables to apply style in geoServer
export class OverlayEmptyLayer {
    constructor(id, name, type, isVisible, legend, selectable, opacity, format, subtitle, nameLegend, hidden) {
        this.polygons = [];
        this.id = id;
        this.name = name;
        this.url = '';
        this.type = type;
        this.subtitle = subtitle;
        this.nameLegend = nameLegend;
        this.isVisible = isVisible;
        this.selectable = selectable || false;
        this.format = format;
        this.version = '';
        this.opacity = opacity || 1;
        this.hidden = hidden || false;
        this.center = false;
        this.bbox = undefined;
        this.legend = legend;
        this.validate();
    }
    /**
     * If the id, name and url properties exist,
     * then return true, otherwise return false.
     * @returns A boolean value. True if all properties exist.
     */
    existProperties() {
        return (ValidationHelper.existProperty(this.id)
            && ValidationHelper.existProperty(this.name));
    }
    /**
     * If the name property is a string, and the visible property is a boolean, and the
     * property is a boolean, then return true.
     *
     * @returns The return value is a boolean. True if type properties are ok.
     */
    sameTypeProperties() {
        return (ValidationHelper.sameTypeProperty(this.id, 'string')
            && ValidationHelper.sameTypeProperty(this.name, 'string'));
    }
    /**
     * If the layer has properties, and the properties are of the same type
     * and the layer has a name, then the layer has properties.
     * @returns a boolean value.
     */
    layerHasProperties() {
        const existProperties = this.existProperties();
        if (!existProperties)
            return false;
        const sameTypeProperties = this.sameTypeProperties();
        if (!sameTypeProperties)
            return false;
        if (this.name === '')
            return false;
        return true;
    }
    /**
     * If the layer doesn't have properties and properties have right type, throw an error.
     */
    validate() {
        const layerHasProperties = this.layerHasProperties();
        if (!layerHasProperties)
            throw new Error(`Layer ${this.name} has an incorrect entering property`);
        return layerHasProperties;
    }
    /**
     * Display again al the polygons related to the pane of the layer.
     */
    show(map) {
        this.polygons.forEach((layer) => {
            layer.addTo(map);
        });
    }
    /**
     * Removes the polygons of the current layer.
     * Before removing, store all the polygons in an temp variable to be able to restore later.
     */
    remove(map) {
        const polygonsSet = new Set(this.polygons);
        const layerToRemoveFromMap = [];
        map.eachLayer((layer) => {
            var _a;
            if (((_a = layer.getPane()) === null || _a === void 0 ? void 0 : _a.id) === this.id) {
                layerToRemoveFromMap.push(layer);
                polygonsSet.add(layer);
            }
        });
        if (layerToRemoveFromMap.length > 0) {
            layerToRemoveFromMap.forEach((layer) => {
                // Remove fom map
                map.removeLayer(layer);
                if (this.isPolyline(layer)) {
                    // eslint-disable-next-line no-underscore-dangle
                    if (layer._path) {
                        map.removeLayer(layer);
                    }
                }
                else {
                    map.removeLayer(layer);
                }
            });
        }
        this.polygons = Array.from(polygonsSet);
    }
    /**
     * Changes the opacity of the layer.
     * @param map leaflet map instance.
     * @param opacity opacity between 0 and 1.
     */
    setOpacity(map, opacity) {
        const pane = map.getPane(this.id);
        if (pane) {
            pane.style.opacity = opacity;
        }
    }
    isPolyline(item) {
        return item instanceof L.Polyline;
    }
}
//# sourceMappingURL=overlayEmptyLayer.js.map